<template>
    <div class="col-md-6 p-0 mr-5">
        <div class="calculator__step">
            <div class="calculator__step--top">
                <b>STORAGE CALCULATOR</b>
            </div>
            <div class="row m-0 calculator__step--content pl-4 pr-4 pt-4">
                <div class="col-md-3" style="color: #1D3354;">
                    <h3>Step 2</h3>
                    <p> Step 2 from 5 </p>
                </div>
                <div class="col-md">
                    <b-form-group>
                        <div class="row m-0 label pb-2 align-items-center">
                          <b>Shipment Volume</b>
                           <div class="__errorMsg text-left ml-2"> {{volume_message}} </div>
                        </div>
                        <div class="__input1">
                            <input @keyup="removeError()" v-model="form.shipmentVolume" class="col-md-6 text-center" type="number">
                            <span class="col-md-6 text-center" v-if="!volume_parameter"> T </span>
                            <span class="col-md-6 text-center" v-else> {{volume_parameter}} </span>
                        </div>
                    </b-form-group>
                    <b-form-group class="customdropdown">
                        <div class="row m-0 label pb-2 align-items-center">
                          <b>Product Type</b>
                          <div class="__errorMsg text-left ml-2"> {{product_message}} </div>
                        </div>
                        <b-dropdown>
                            <template slot="button-content">
                            {{ productValue}}
                            </template>
                            <b-dropdown-item @click="selectedOption(item)"  v-for="(item,i) in optionsProductType" :key="i" >
                                <span>{{ item.text }}</span>
                            </b-dropdown-item>
                        </b-dropdown>
                        <img class="__imgArrow" src = "@/assets/image/instantprice/right-arrow.svg">
                    </b-form-group>
                </div>
            </div>
            <div class="row m-0 calculator__step--bottom justify-content-end p-4 pt-5">
                <button class="_global__button--corporite pl-4 pr-4"  @click="emitToParent('CalcStep1')">Back</button>
                <button class="_global__button--corporite pl-4 pr-4 ml-4"  @click="emitToParent('CalcStep3')">Next</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CalcStep2',
  props: {
    mainData: Object,
    volume_parameter: String
  },
  data: () => ({
    load: false,
    productValue: 'Choose Product Type',
    volume_message: '',
    product_message: '',
    form: {
      stepName: '',
      shipmentVolume: '',
      productType: ''
    },
    optionsProductType: [
      { text: 'General Cargo', value: '3' },
      { text: 'Dangerous Goods', value: '2' }
    ],
    payloadLog: {
      featureName: 'STORAGE CALCULATOR',
      featureStep: 2,
      stepName: 'Shipment Volume, Product Type',
      featureProcess: {
        status: 'success',
        data: {}
      }
    }
  }),
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // insert log
      this.payloadLog.featureProcess.data = this.form
      this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
    },
    volumeChecking (data) {
      if (!this.form.shipmentVolume && !this.form.productType) {
        this.volume_message = 'This field is required*'
        this.product_message = 'This field is required*'
      } else if (!this.form.shipmentVolume) {
        this.volume_message = 'This field is required*'
      } else if (!this.form.productType) {
        this.product_message = 'This field is required*'
      } else {
        this.form.stepName = data
        this.$emit('activeForm', this.form)
      }
    },
    emitToParent (data) {
      if (data === 'CalcStep1') {
        this.$emit('changeParameter', '')
        this.form.stepName = data
        this.$emit('activeForm', this.form)
      } else {
        this.volumeChecking(data)
      }
    },
    removeError () {
      this.volume_message = ''
    },
    selectedOption (item) {
      this.productValue = item.text
      this.form.productType = item.value
      this.product_message = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/storagecalculator/CalcStep2.vue